import { render, staticRenderFns } from "./PostListModal.vue?vue&type=template&id=97230bde&"
import script from "./PostListModal.vue?vue&type=script&lang=js&"
export * from "./PostListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97230bde')) {
      api.createRecord('97230bde', component.options)
    } else {
      api.reload('97230bde', component.options)
    }
    module.hot.accept("./PostListModal.vue?vue&type=template&id=97230bde&", function () {
      api.rerender('97230bde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/post-list-modal/PostListModal.vue"
export default component.exports